import styled from 'styled-components';

import { Checkbox } from 'components/uikit/Form/Checkbox/Checkbox';
import { FormGridRowBase } from '../../AnketaForm.styles';
import { AnketaFio, AnketaInputMask, AnketaSelect } from '../../../MainAnketa.styles';

export const FormGridRow = styled(FormGridRowBase)`
  grid-template-areas:
    '. fio fio fio fio cp cp .'
    '. tgl tgl tgl . . . .'
    '. fio2 fio2 fio2 fio2 fio2 fio2 .'
    '. ge ge . . . . . '
    '. bd bd . . sg sg . '
    '. mrg mrg ch ch ed ed .'
    '. bo bo bu bu . . .'
    '. ym ym . . . . .';
`;

export const FioUser = styled(AnketaFio)`
  grid-area: fio;
  margin-bottom: 16px;
`;

export const MobilePhone = styled(AnketaInputMask)`
  grid-area: cp;
`;

export const ChangeFioToogle = styled(Checkbox).attrs({ size: 'xs' })`
  position: relative;
  bottom: ${(p) => (p.otherError ? '3px' : '14px')};
  grid-area: tgl;
`;

export const PrevFioUser = styled(AnketaFio)`
  grid-area: fio2;
`;

export const MaritalStatus = styled(AnketaSelect)`
  grid-area: mrg;
`;

export const ChildrenCount = styled(AnketaInputMask)`
  grid-area: ch;
`;

export const Education = styled(AnketaSelect)`
  grid-area: ed;
`;
